<template>
  <div>
    <vs-card>
      <b-row align-v="center">
        <b-col cols="3">
          <input type="file" accept=".xlsx,.xls" @change="onChange" />
        </b-col>
        <b-col cols="3">
          Örnek Excel Şablonu
          <a
            :href="'http://sistem.uzum.com.tr/assets/' + ornekSablon"
            download
          >İNDİR</a>
        </b-col>
        <b-col style="text-align: end">
          <UrunCekComponent style="margin-right: 10px" />
          <vs-button
            style="border-radius: 5px; margin-right: 10px"
            color="primary"
            type="border"
            v-on:click="jobListPopupActive = true"
          >
            Yüklenen Excel'ler
          </vs-button>
          <vs-button
            v-if="excelBase64"
            style="border-radius: 5px"
            variant="primary"
            v-on:click="fiyatGuncelle()"
            id="button-with-loading-fiyat"
            class="vs-con-loading__container"
          >
            Fiyat Güncelle
          </vs-button>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 400px; margin-top: 15px"
        class="ag-theme-alpine"
        :enableCellChangeFlash="true"
        :animateRows="true"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        :suppressCopyRowsToClipboard="true"
        :pagination="true"
        @grid-ready="onGridReady"
      >
      </ag-grid-vue>
    </vs-card>

    <TopluFiyatJobListesi
      :is-active="jobListPopupActive"
      @close="jobListPopupActive = false"
    />
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import state from "../../store/state";
import Store from "../../store/store";
import XLSX from "xlsx";
import TopluFiyatJobListesi from "./TopluFiyatJobListesi.vue";
import UrunCekComponent from "../components/uzum-components/stoklistesi-components/UrunCekComponent.vue";

export default {
  components: {
    AgGridVue,
    TopluFiyatJobListesi,
    UrunCekComponent,
  },
  data() {
    return {
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: [],
      localeText: null,
      rowData: [],
      fileName: "",
      excelBase64: "",
      jobListPopupActive: false,
      ornekSablon: "TopluFiyatGuncelleOrnekSablon.xlsx",
      kolonGruplari: [
        { grup: "Ürün Bilgisi", alanlar: ["Stok Kodu", "Barkod"] },
        { grup: "Trendyol", alanlar: ["Trendyol Listeleme Fiyatı", "Trendyol Satış Fiyatı"] },
        { grup: "Beymen", alanlar: ["Beymen Listeleme Fiyatı", "Beymen Satış Fiyatı"] },
        { grup: "Boyner", alanlar: ["Boyner Listeleme Fiyatı", "Boyner Satış Fiyatı"] },
        { grup: "Shopify", alanlar: ["Shopify Listeleme Fiyatı", "Shopify Satış Fiyatı"] },
        { grup: "Hepsiburada", alanlar: ["Hepsiburada Listeleme Fiyatı", "Hepsiburada Satış Fiyatı"] },
        { grup: "Lcwaikiki", alanlar: ["Lcwaikiki Listeleme Fiyatı", "Lcwaikiki Satış Fiyatı"] },
      ],
    };
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    bildir(text, color, title) {
      this.$vs.notify({
        title,
        text,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color,
        position: "top-center",
      });
    },
    soapIstek(metod, args) {
      return new Promise((resolve, reject) => {
        const soap = require("soap");
        soap.createClient(state.sistemAddress, (err, client) => {
          if (err) return reject(err);
          client[metod](args, (err, result) => {
            if (err) return reject(err);
            const ham = result && result[metod + "Result"];
            if (ham == "-1") {
              Store.dispatch("logout");
              return reject(new Error("logout"));
            }
            try {
              resolve(JSON.parse(ham));
            } catch (parseError) {
              reject(parseError);
            }
          });
        });
      });
    },
    onChange(e) {
      const vm = this;
      const file = e.target.files[0];
      if (!file) return;
      vm.fileName = file.name;

      const reader = new FileReader();
      reader.onload = function (ev) {
        try {
          const data = new Uint8Array(ev.target.result);

          // Dosyanın tamamını base64'e çevir (backend'e bu şekilde gönderilecek)
          let binary = "";
          for (let i = 0; i < data.length; i++) {
            binary += String.fromCharCode(data[i]);
          }
          vm.excelBase64 = btoa(binary);

          const workbook = XLSX.read(data, { type: "array", cellDates: true });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          vm.rowData = XLSX.utils.sheet_to_json(worksheet, { range: 1 });
        } catch (error) {
          console.log(error);
          vm.bildir("Excel formatınızın doğruluğundan emin olun.", "warning");
        }
      };
      reader.readAsArrayBuffer(file);
    },
    kolonlariAyarla() {
      this.columnDefs = this.kolonGruplari.map((grup) => ({
        headerName: grup.grup,
        children: grup.alanlar.map((field) => ({
          field: field,
          filter: "agSetColumnFilter",
          wrapText: true,
          autoHeight: true,
        })),
      }));
    },
    async fiyatGuncelle() {
      const vs = this.$vs;
      vs.loading({ container: "#button-with-loading-fiyat", type: "material" });

      try {
        const veriler = await this.soapIstek("topluFiyatExcelYukle", {
          token: Store.state.tokenId,
          dosyaAdi: this.fileName,
          excelBase64: this.excelBase64,
        });

        const basarili = veriler.response == "Ok" && veriler.error == "No";
        this.bildir(
          basarili
            ? "Fiyat güncelleme işleme alınmıştır."
            : veriler.mesaj || "Fiyat güncelleme başarısız.",
          basarili ? "success" : "danger"
        );
      } catch (error) {
        console.log(error);
        if (error.message !== "logout") this.bildir("Başarısız", "danger");
      } finally {
        vs.loading.close("#button-with-loading-fiyat > .con-vs-loading");
      }
    },
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.kolonlariAyarla();
  },
};
</script>
